import { GET_COUNTRIES } from '../../../website/static/js/application/lib/constants';

export const formatCountriesToSelectOptions = () =>
  GET_COUNTRIES().map(([value, label]) => ({ value, label }));

// Collections copied from website/static/js/models/Regions.js

// FHCORE-11298: GDPR country codes.
export const GDPR_COUNTRY_CODES = [
  'AN',
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'NO', // Added from EU_PROCESSOR_COUNTRIES server/server/settings/__init__.py
  'CH', // Added from EU_PROCESSOR_COUNTRIES server/server/settings/__init__.py
];
